<mat-form-field class="field treo-mat-no-subscript">
  <mat-label>{{ label }}</mat-label>
  <mat-chip-list #chipList aria-label="User selection" class="mat-chip-list">
    <mat-chip
      *ngFor="let tag of tags; let i = index"
      [selectable]="selectable"
      [removable]="removable"
      (removed)="removeTag(i)"
    >
      {{ tag }}
      <mat-icon matChipRemove class="m-0">cancel</mat-icon>
    </mat-chip>
    <input
      placeholder="Start typing name or email address and press enter when done..."
      #contactInput
      [formControl]="autocompleteCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="addTag($event)"
    />
  </mat-chip-list>
  <div class="copy-fields-toggles" matSuffix *ngIf="showCCFields">
    <span class="cc-toggle" (click)="showCopyField('cc')"> Cc </span>
    <span class="bcc-toggle" (click)="showCopyField('bcc')"> Bcc </span>
  </div>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectContact($event)">
    <mat-option *ngFor="let contact of contactList" [value]="contact.name" [id]="contact.email">
      {{ contact.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
